import React from 'react'
import Moment from 'react-moment'
import { lower } from 'change-case'
import { Icon } from 'semantic-ui-react'
import r from 'reactotron-react-js'

import { StatusTag } from 'components'
import { DivText } from './styled'

export const grStatus = {0:'Draft',1:'New',2:'In Progress',3:'Revise',4:'Completed',5:'Reject',6:'Cancelled'}

export const selectMainDeliveryType = (deleveryTypeList) =>{
  return deleveryTypeList.map(x=>({ text: x.mainDeliveryType, value: x.mainDeliveryType, color: 'blue' }))
}

export const selectSubDeliveryType = (mainDeliveryType,deleveryTypeList) =>{
  let gt = deleveryTypeList.find(x=>lower(x.mainDeliveryType)===lower(mainDeliveryType))
  if(gt){
    return gt.subDeliveryTypes.map(x=>({value:x.subDeliveryType,text:x.subDeliveryType}))
  }else{
    return []
  }
}

export const selectAttachmentGroup = (mainType, subType, list, vendorCode, isFormVendor=false) => {
  if ((subType || '').toUpperCase() === 'MIGRATION') {
    return [
      {
        name: 'เอกสารส่งมอบงาน',
        code: 'GR04',
        isRequire: false,
        isAdditional: false
      }, {
        name: 'Other',
        code: 'GR07',
        isRequire: false,
        isAdditional: false
      },
    ]
  } else {
    let gt = list.find(x => lower(x.mainDeliveryType) === mainType.toLowerCase())
    if (gt) {
      let st = gt.subDeliveryTypes.find(x => x.subDeliveryType.toLowerCase() === subType.toLowerCase())
      if (st) {
        let clone = JSON.parse(JSON.stringify(st.attachmentGroup))
        let ii = clone.findIndex(x=>x.code.toLowerCase()==='gr04')
        if(ii>=0&&(mainType.toLowerCase()=='goods'||isFormVendor)){
          clone.splice(ii,1)
        }
        if(vendorCode&&(vendorCode.startsWith('9')||vendorCode.startsWith('6'))){
          let iii = clone.findIndex(x=>x.code.toLowerCase()==='gr02')
          if(iii>=0&&(mainType.toLowerCase()=='service')){
            clone.splice(iii,1)
          }
        }
        return clone
      }
    }
  }

  return []
}

export const withholdingTaxList = [
  {
    value: 'amount',
    text: 'Amount',
  },
  {
    value: 1,
    text: '1%',
  },
  {
    value: 2,
    text: '2%',
  },
  {
    value: 3,
    text: '3%',
  },
  {
    value: 5,
    text: '5%',
  },
  {
    value: 10,
    text: '10%',
  },
  {
    value: 0,
    text: 'Tax Exampted',
  }
]

export const columns = { 
  tRFQs:[
    {
      Header: '',
      accessor: 'isSpecialCreditTerm',
      width: 30,
      Cell:row=>(row.value&&<DivText><Icon name='star' color='yellow'/></DivText>)
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell:row=>(<DivText><StatusTag status={row.value} statusName={grStatus[row.value]}/></DivText>)
    },
    {
      Header: 'Doc No.',
      accessor : row =>(row.status === 0 ? '-' : row.docNo),
      id:'docNo',
      width: 100,
      Cell:row=>(<DivText>{row.value}</DivText>)
    },{
      Header: 'PR No.',
      accessor : 'prNo',
      width: 100,
      Cell:row=>(<DivText>{row.value}</DivText>)
    },{
      Header: ()=>(<DivText left>Title</DivText>),
      accessor : row =>(row.title.trim()),
      id:'title',
      width: 250
    }, {
      Header: ()=>(<DivText left>Project name</DivText>),
      accessor: 'projectName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Vendor',
      accessor: 'vendorName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Company',
      accessor : 'companyName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Priority',
      accessor: 'priority',
      width: 70,
      Cell: row => (
        row.value && 
        <DivText>
          <div className={`priority ${row.value}`}>
            {row.value.toUpperCase()}
          </div>
        </DivText>)
    },{
      Header: ()=>(<DivText left>Requester</DivText>),
      accessor: 'requesterName',
      width: 100,
      Cell: row => (row.value&&<DivText left>{`${row.value||'-'}`}</DivText>)
    },
    // {
    //   Header: 'Overdue',
    //   id:'overdue',
    //   accessor : row =>(Math.floor(row.pendingDays-row.slaDays)),
    //   width: 70,
    //   Cell: row => (<DivText>{`${ row.value>=1?`(${row.value} days)`:'-'}`}</DivText>)
    // }, 
    // SLA Status
    // SLA Remaining
    {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value&&
        <DivText>
          {row.value?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value&&<DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ],
}